import React, { memo, RefObject, useState, useEffect, useMemo } from "react";
import styles from "./CaptionsPanel.module.css";
import Caption from "./Caption";
import { VideoCaption } from "../../../../../common/video/models/VideoCaption";
import RerunSTTComponent from "../../../../../pages/vod/Common/RerunSTT";
import PuiTypography from "../../../../../components/elements/PuiTypography";
import { isAdmin, isEditor } from "../../../../../utils/LogicUtils";
import { useSelector } from "react-redux";
import { AppState } from "../../../../../root/RootReducer";
import { IsDevice } from "../../../../../components/function/useDeviceFlag";
import SelectLanguage from "../../../../../pages/vod/Common/SelectLanguage";
import { Video } from "../../../../../common/video/models/Video";
import { t } from "i18next";

interface CaptionsPanelProps {
    video: Video;
    captions: VideoCaption[];
    videoRef: RefObject<HTMLVideoElement>;
    currentVideoTimeMs: number;
    setEditModalOpen: (target: boolean) => void;
}

function CaptionsPanel({
    video,
    captions,
    videoRef,
    currentVideoTimeMs,
    setEditModalOpen,
}: CaptionsPanelProps) {
    const { user } = useSelector((state: AppState) => ({
        user: state.user.user,
    }));
    const [currentCaptionIndex, ChangeCurrentCaptionIndex] = useState(-1);

    const endMillisList: number[] = useMemo(() => {
        const list:number[] = [];
        captions.forEach(function (row) {
            //重複した秒数をendMillisListに入れない。
            if(list.indexOf(row.endMillis) === -1){
                list.push(row.endMillis);
            }
        });
        return list;
    },[captions]);

    //表示言語切り替え
    const [selectLanguage, setSelectLanguage] = useState<string>("ja");

    // 現在のキャプションのインデックスを決める
    useEffect(() => {
        ChangeCurrentCaptionIndex(
            endMillisList.findIndex((endTime) => endTime > currentVideoTimeMs)
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentVideoTimeMs]);

    return (
        <div className={styles.root}>
            <div className={styles.tabArea}>
                {IsDevice("desktop") &&
                    (isAdmin(user?.roles) || isEditor(user?.roles)) &&
                    captions.length > 0 && <RerunSTTComponent video={video} />}
                {captions.length > 0 ? (
                    <div className={styles.selectLanguage}>
                        <SelectLanguage
                            captions={video.captionLanguageList}
                            selectLanguage={selectLanguage}
                            setInputLanguage={setSelectLanguage}
                            isSearch={false}
                        />
                    </div>
                ) : (
                    <div className={styles.msg}>
                        <PuiTypography color="secondary-font">
                            {t("音声が存在しません。")}
                        </PuiTypography>
                    </div>
                )}
            </div>
            <div className={styles.captionListArea}>
                <div className={styles.captionList} id="captionTop">
                    {video.status.includes("TRANSLATE") && (
                        <div className={styles.captionList}>
                            <PuiTypography size={14}>{t("翻訳中です")}</PuiTypography>
                        </div>
                    )}
                    {captions
                        .filter((current) => current.language === selectLanguage)
                        .map((segment, index) => (
                            <Caption
                                key={index}
                                isCurrentCaption={index === currentCaptionIndex}
                                videoRef={videoRef}
                                startTimeMillis={segment.startMillis}
                                id={segment.id}
                                text={segment.transcript}
                                captionElement={document.getElementById("captionTop")}
                                setEditModalOpen={setEditModalOpen}
                                isEdited={segment.isEdited}
                                language={segment.language}
                            >
                                <PuiTypography color="secondary-font">
                                    {segment.transcript}
                                </PuiTypography>
                            </Caption>
                        ))}
                </div>
            </div>
        </div>
    );
}

export default memo(CaptionsPanel);
